export const defaultLocale = 'pl';
